import { useApesStorageApi } from "@/api/useApesStorageApi";
import { ModalName } from "@/components/Modal/modal-name";
import { useModal } from "@/composables/useModal";
import { useToast } from "@/composables/useToast";
import { useToastTransaction } from "@/composables/useToast/useToastTransaction";
import { Config } from "@/config";
import { captureError } from "@/helpers/captureError";
import { resizeImageCF } from "@/helpers/resize-image-cloudflare";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import { useLootBoxContract } from "@/web3/contracts";

export const openLootBox = async ({ type, amount }) => {
  try {
    // const itms = [
    //   {
    //     id: 105,
    //     image:
    //       "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/a1091d8b-0ba2-4f85-fd1a-b74ddf43a600/w=256",

    //     rarity: "common",
    //     stars: 3,
    //   },
    //   {
    //     id: 525,
    //     image:
    //       "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/df31f8ad-06bf-4fd4-f4c6-05a5aa3dd500/w=256",
    //     rarity: "common",
    //     categoryName: "Clothing",
    //     stars: 5,
    //   },
    //   {
    //     id: 804,
    //     image:
    //       "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/4b1874ea-c0c3-44b1-e983-48bf207af400/w=256",
    //     rarity: "common",
    //     stars: 2,
    //   },
    //   {
    //     id: 885,
    //     image:
    //       "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/51c11073-6973-48d0-a699-181040985300/w=256",
    //     rarity: "common",
    //   },
    //   {
    //     id: 893,
    //     image:
    //       "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/35a11441-9695-478c-d39f-b759b856d800/w=256",
    //     rarity: "common",
    //   },
    // ];
    // useModal().open({
    //   name: ModalName.LootBoxOpenModal,
    //   props: {
    //     type: "common",
    //     winningIds: [525, 804, 893],
    //     items: itms,
    //   },
    // });
    // return;
    // Check apes
    if (!useWalletCollectionStore().apes.length) {
      useToast().error({
        title: "You must have an Ape in your wallet to open a Loot Box",
      });
      return;
    }
    const wallet = useWeb3Store().walletAddress;
    const data = await useApesStorageApi({
      throw: true,
      toast: { error: true },
    }).exec({
      url: "/lootBox/open",
      params: {
        type,
        wallet,
        amount,
        network: Config.network.name,
      },
    });
    if (!data) throw new Error("Couldn't sign lootbox transaction");
    const { timeOut, randomSeed, signature, price } = data;
    const contract = useLootBoxContract(true);

    const result = await useToastTransaction(
      contract.methods.openSpecialBox(
        amount,
        price,
        type === "epic" ? 1 : 2,
        timeOut,
        randomSeed,
        signature
      ),
      {
        text: `Opening ${amount} ${
          type.charAt(0).toUpperCase() + type.slice(1)
        } Loot Box${amount > 1 ? "es" : ""}`,
        sendOptions: {
          value: price,
        },
      }
    );
    let winningIds = result.events.SpecialBoxOpened.returnValues.prizes;
    winningIds = winningIds.map(Number);
    console.log(winningIds);
    const extraImages = (amount - 1) * 20;
    const images = await useApesStorageApi({
      throw: true,
      toast: { error: true },
    }).exec({
      url: "/lootBox/images",
      params: {
        signature,
        txHash: result.transactionHash,
        extraImages,
        type: extraImages ? type : undefined,
      },
    });
    const lootBoxItems = images.map((item) => {
      const image =
        item.unisexPreviewImageSrc ||
        item.malePreviewImageSrc ||
        item.femalePreviewImageSrc;

      return {
        ...item,
        image: resizeImageCF(image, "512"),
      };
    });
    useModal().open({
      name: ModalName.LootBoxOpenModal,
      props: {
        type,
        winningIds,
        items: lootBoxItems,
      },
    });
  } catch (err) {
    // useToast().error({ title: "Couldn't open Loot Box, please try again" });
    captureError(err);
  }
};
